import React from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import Background from "../../assets/platKapalGambar.PNG";

const Aplikasi = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* APLIKASI PC */}
      <section className="hidden sm:block">
        <h1 className="text-4xl container-screen text-primaryPandawa font-helvetica text-left">
          TEAM SURAT JALAN
        </h1>
        <section className="container-screen grid grid-cols-5 py-10">
          <div className="col-span-5">
            <div>
              <div className="text-left">
                <div>
                  <div className="flex items-center gap-2">
                    <h2 className="font-helvetica font-bold ">
                      Job Description
                    </h2>
                  </div>
                </div>
              </div>

              <div className="mt-4">
                <ul className="list-disc list-outside pl-5 space-y-2 text-gray-700 text-left">
                  <li className="font-montserrat">
                    Membuat dan mencetak surat jalan sesuai dengan permintaan
                    pengiriman.
                  </li>
                  <li className="font-montserrat">
                    Memastikan informasi pada surat jalan akurat dan sesuai
                    dengan barang yang dikirim (jenis barang, jumlah, tujuan,
                    dan kendaraan).
                  </li>
                  <li className="font-montserrat">
                    Berkoordinasi dengan tim gudang, sales, dan ekspedisi
                    terkait jadwal pengiriman dan data barang.
                  </li>
                  <li className="font-montserrat">
                    Mengarsipkan surat jalan secara rapi, baik fisik maupun
                    digital.
                  </li>
                  <li className="font-montserrat">
                    Melakukan rekap surat jalan harian, mingguan, dan bulanan.
                  </li>
                  <li className="font-montserrat">
                    Memastikan sopir dan ekspedisi menerima dokumen pengiriman
                    yang lengkap dan sah.
                  </li>
                  <li className="font-montserrat">
                    Melakukan verifikasi surat jalan yang telah kembali dan
                    menyesuaikannya dengan bukti penerimaan barang.
                  </li>
                  <li className="font-montserrat">
                    Membantu pelaporan administrasi pengiriman ke bagian
                    terkait.
                  </li>
                  <li className="font-montserrat">
                    Berpengalaman dalam pembuatan dan pengelolaan dokumen
                    pengiriman.
                  </li>
                </ul>
              </div>

              <div className="text-left mt-10">
                <div className="flex items-center gap-2">
                  <h2 className="font-helvetica font-bold ">Kualifikasi</h2>
                </div>
              </div>

              <div className="mt-4">
                <ul className="list-disc list-outside pl-5 space-y-2 text-gray-700 text-left">
                  <li className="font-montserrat">
                    Mengerti dan menggunakan komputer dan office application.
                  </li>
                  <li className="font-montserrat">
                    Memiliki insiatif untuk belajar mengenai pekerjaan
                    administratif.
                  </li>
                  <li className="font-montserrat">
                    Memahami alur pembuatan surat jalan.
                  </li>
                  <li className="font-montserrat">
                    Disiplin, bisa bekerja under pressure, on time, bisa bekerja
                    secara teamwork dan memiliki mental yang kuat.
                  </li>
                  <li className="font-montserrat">
                    Bisa menggunakan Accurate lebih diutamakan.
                  </li>
                </ul>
              </div>

              <div className="text-left mt-10">
                <div className="flex items-center gap-2">
                  <h2 className="font-helvetica font-bold ">
                    Keterampilan Lain
                  </h2>
                </div>
              </div>

              <div className="mt-4">
                <ul className="list-disc list-outside pl-5 space-y-2 text-gray-700 text-left">
                  <li className="font-montserrat">
                    Teliti, cekatan, dan rapi dalam administrasi dokumen.
                  </li>
                  <li className="font-montserrat">
                    Jujur, bertanggung jawab, dan mampu bekerja dengan tenggat
                    waktu.
                  </li>
                  <li className="font-montserrat">
                    Memiliki kemampuan komunikasi dan koordinasi yang baik.
                  </li>
                  <li className="font-montserrat">
                    Mampu bekerja sama dalam tim maupun individu.
                  </li>
                </ul>
              </div>

              <div className="text-left mt-10">
                <div className="flex items-center gap-2">
                  <h2 className="font-helvetica font-bold ">Kondisi Kerja</h2>
                </div>
              </div>

              <div className="mt-4">
                <ul className="list-disc list-outside pl-5 space-y-2 text-gray-700 text-left">
                  <li className="font-montserrat">
                    Bersedia bekerja lembur jika diperlukan, terutama saat
                    pengiriman padat.
                  </li>
                </ul>
              </div>
            </div>
            <div className="lg:mt-10 flex justify-start">
              <button
                onClick={() =>
                  window.open(
                    "https://mail.google.com/mail/?view=cm&fs=1&to=hr@pandawajayasteel.co.id&su=Lamaran%20Kerja%20-%20Team%20Surat%20Jalan&body=Halo%2C%20saya%20ingin%20melamar%20untuk%20posisi%20ini",
                    "_blank"
                  )
                }
                className="bg-primaryPandawa hover:bg-primaryPandawa/90 transition duration-300 px-6 py-3 rounded-lg shadow-md text-white font-semibold"
              >
                Lamar Sekarang
              </button>
            </div>
            <p className="text-left text-xs mt-2 text-gray-500">
              *Jika terdapat kendala silahkan lampirkan CV secara manual ke
              hr@pandawajayasteel.co.id
            </p>
          </div>
          {/* <div className="col-span-2 rounded-lg overflow-hidden ml-auto h-full w-3/4">
            <img src={Background} className="h-full" alt="Background" />
          </div> */}
        </section>
      </section>

      {/* MOBILE VERSION */}
      {/* MOBILE VERSION */}
      <section className="sm:hidden bg-white py-8">
        <div className="container-screen text-left">
          <h1 className="font-helvetica text-primaryPandawa text-left text-2xl mb-6 font-bold">
            TEAM SURAT JALAN
          </h1>

          {/* Job Description */}
          <div className="mb-8">
            <h2 className="font-helvetica font-bold text-lg mb-3 text-primaryPandawa">
              Job Description
            </h2>
            <ul className="list-disc list-outside pl-5 space-y-2 text-gray-800 text-sm">
              <li>
                Membuat dan mencetak surat jalan sesuai dengan permintaan
                pengiriman.
              </li>
              <li>
                Memastikan informasi pada surat jalan akurat dan sesuai dengan
                barang yang dikirim (jenis barang, jumlah, tujuan, dan
                kendaraan).
              </li>
              <li>
                Berkoordinasi dengan tim gudang, sales, dan ekspedisi terkait
                jadwal pengiriman dan data barang.
              </li>
              <li>
                Mengarsipkan surat jalan secara rapi, baik fisik maupun digital.
              </li>
              <li>
                Melakukan rekap surat jalan harian, mingguan, dan bulanan.
              </li>
              <li>
                Memastikan sopir dan ekspedisi menerima dokumen pengiriman yang
                lengkap dan sah.
              </li>
              <li>
                Melakukan verifikasi surat jalan yang telah kembali dan
                menyesuaikannya dengan bukti penerimaan barang.
              </li>
              <li>
                Membantu pelaporan administrasi pengiriman ke bagian terkait.
              </li>
              <li>
                Berpengalaman dalam pembuatan dan pengelolaan dokumen
                pengiriman.
              </li>
            </ul>
          </div>

          {/* Kualifikasi */}
          <div className="mb-8">
            <h2 className="font-helvetica font-bold text-lg mb-3 text-primaryPandawa">
              Kualifikasi
            </h2>
            <ul className="list-disc list-outside pl-5 space-y-2 text-gray-800 text-sm">
              <li>Mengerti dan menggunakan komputer dan office application.</li>
              <li>
                Memiliki inisiatif untuk belajar mengenai pekerjaan
                administratif.
              </li>
              <li>Memahami alur pembuatan surat jalan.</li>
              <li>
                Disiplin, bisa bekerja under pressure, on time, bisa bekerja
                secara teamwork dan memiliki mental yang kuat.
              </li>
              <li>Bisa menggunakan Accurate lebih diutamakan.</li>
            </ul>
          </div>

          {/* Keterampilan Lain */}
          <div className="mb-8">
            <h2 className="font-helvetica font-bold text-lg mb-3 text-primaryPandawa">
              Keterampilan Lain
            </h2>
            <ul className="list-disc list-outside pl-5 space-y-2 text-gray-800 text-sm">
              <li>Teliti, cekatan, dan rapi dalam administrasi dokumen.</li>
              <li>
                Jujur, bertanggung jawab, dan mampu bekerja dengan tenggat
                waktu.
              </li>
              <li>Memiliki kemampuan komunikasi dan koordinasi yang baik.</li>
              <li>Mampu bekerja sama dalam tim maupun individu.</li>
            </ul>
          </div>

          {/* Kondisi Kerja */}
          <div className="mb-8">
            <h2 className="font-helvetica font-bold text-lg mb-3 text-primaryPandawa">
              Kondisi Kerja
            </h2>
            <ul className="list-disc list-outside pl-5 space-y-2 text-gray-800 text-sm">
              <li>
                Bersedia bekerja lembur jika diperlukan, terutama saat
                pengiriman padat.
              </li>
            </ul>
          </div>
          <div className="text-center mt-8 w-full">
            <button
              onClick={() =>
                (window.location.href =
                  "mailto:hr@pandawajayasteel.co.id?subject=Lamar%20Pekerjaan%20-%20Team%20Surat%20Jalan")
              }
              className="bg-primaryPandawa hover:bg-primaryPandawa/90 transition duration-300 px-6 py-3 rounded-lg shadow-md text-white font-semibold w-full"
            >
              Lamar Sekarang
            </button>
            <p className=" text-xs mt-2 text-gray-500">
              *Jika terdapat kendala silahkan lampirkan CV secara manual ke
              hr@pandawajayasteel.co.id
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Aplikasi;
